(function (){
    'use strict',
        angular
            .module('ib-tab-panel-module', []);
})();